__turbopack_context__.v({
  "_zoomed": "GalleryMedia-module-scss-module__2PnXlG___zoomed",
  "backdrop": "GalleryMedia-module-scss-module__2PnXlG__backdrop",
  "image": "GalleryMedia-module-scss-module__2PnXlG__image",
  "root": "GalleryMedia-module-scss-module__2PnXlG__root",
  "video": "GalleryMedia-module-scss-module__2PnXlG__video",
  "zoomButton": "GalleryMedia-module-scss-module__2PnXlG__zoomButton",
});
